import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    status: false,
    error: "",
  },
  action = {}
) {
  switch (action.type) {
    case homeConstants.GET_APP_IDENTITY_REQUEST:
      return {
        ...state,
        data: null,
        status: false,
        isProgress: true,
      };
    case homeConstants.GET_APP_IDENTITY_SUCCESS:
      return {
        data: action.response.data,
        status: true,
        isProgress: false,
      };
    case homeConstants.GET_APP_IDENTITY_FAILURE:
      return {
        data: null,
        error: action.error,
        status: true,
        isProgress: false,
      };
    case homeConstants.RESET_APP_IDENTITY_REQUEST:
      return {
        data: null,
        status: false,
        isProgress: false,
      };
    default:
      return state;
  }
}
